import isString from 'lodash/isString'

import { IAddress } from '@shared/models/proto/base/address'
import { Nullable } from '@shared/models/types/primary'
import { numeric } from '@shared/utils/helpers/numeric-formatter'

// Tries to parse a string as a JSON object and return it, but if that doesn't work then it returns the original string
// eslint-disable-next-line
export function convertStringToJson(str?: any) {
  if (!isString(str)) {
    return str
  }

  try {
    return JSON.parse(str)
  } catch (e) {
    return str
  }
}

export const getFormattedTime = (time: number) => (time > 9 ? time : `0${time}`)

export const timeUnitsSplitter = (time: string) => {
  const timeHelper = time.split(':')
  return {
    hours: numeric(timeHelper?.[0] ?? 0),
    minutes: numeric(timeHelper?.[1] ?? 0),
  }
}

// eslint-disable-next-line
export const getValidStringFromOptionalValues = <V = any>(
  values: Nullable<V | undefined>[],
  spare = ''
) =>
  values
    .map((value) => value ?? spare)
    .join(' ')
    .replace(/\s\s+/g, ' ')

export const getInitials = (fullName: string) =>
  fullName
    .split(' ')
    .map((name) => name[0])
    .join('')
    .slice(0, 2)

export const getAddressReadableString = (
  address: Nullable<IAddress | undefined>
) =>
  getValidStringFromOptionalValues([
    address?.firstLine,
    address?.secondLine,
    address?.city,
    address?.stateCode,
    address?.zip,
    address?.countryCode,
  ])

export const removeSpaces = (str: string) => str.split(' ').join('')
